export interface BuildingApiType {
    id: number;
    currentCapacity: number;
    currentMaxCapacity: number;
    currentHealth: number;
    currentDailyProduction: number;
    buildingId: number;
    state: number;
    currentLevel: number;
    name: string;
    trainingQueue: number;
    maxQueue: number;
    photo: string;
    video: string;
    bonusLevel: number;
    discount: number;
    upgradeEmberReward: number;
    instantUpgradeEmberReward: number;
    nextEventDate?: string;
}

export enum PlayerBuildingState {
    Unavailable = -1,
    NotHave = 0,
    Ready = 1,
    Mining = 2,
    Down = 3,
    Full = 4,
    Upgrading = 5
}